/**
 * Type guard to check if a given key exists on the provided object.
 * T - The object type.
 * @param key - The property key to check.
 * @param obj - The object to check the key against.
 * @returns True if the key exists on the object, otherwise false.
 */
export function isPropertyOf<T extends object>(
  key: string | number | symbol,
  obj: T,
): key is keyof T {
  return key in obj;
}
